import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import CloudConfig from "./CloudConfig.js";
import URLConfig from "./URLConfig.js";

var CloudinaryConfig = /*#__PURE__*/function () {
  function CloudinaryConfig() {
    var configurations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, CloudinaryConfig);

    this.cloud = new CloudConfig(configurations.cloud);
    this.url = new URLConfig(configurations.url || {});
  }
  /**
   * @description Setter for the cloudConfig
   * @param {ICloudConfig} cld
   */


  _createClass(CloudinaryConfig, [{
    key: "setCloudConfig",
    value: function setCloudConfig(cld) {
      this.cloud = new CloudConfig(cld);
      return this;
    }
    /**
     * @description Setter for the urlConfig
     * @param {IURLConfig} url
     */

  }, {
    key: "setURLConfig",
    value: function setURLConfig(url) {
      this.url = new URLConfig(url);
      return this;
    }
  }, {
    key: "extend",
    value: function extend(configurations) {
      this.cloud = this.cloud.extend(configurations.cloud || {});
      this.url = this.url.extend(configurations.url || {});
      return this;
    }
  }]);

  return CloudinaryConfig;
}();

export default CloudinaryConfig;